import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import PaymentPage from './PaymentPage';
import { ProductType } from '../../constants/enum';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { useStore } from '../../contexts/StoreProvider';

const TestPayment = () => {
    const { state } = useLocation();
    const { adminStore } = useStore();
    const { getPaymentSetting, allPaymentSettingInfo } = adminStore;
    useEffect(() => {
        getPaymentSetting();
    }, []);

    const getTestAmount = () => {

        if (allPaymentSettingInfo.length === 0) return undefined;

        const setting = allPaymentSettingInfo.find(
            s => s.ProductType === ProductType.Test
        );

        if (!setting) return undefined;
        return setting.JPY;
    }
    const amount = getTestAmount();

    if (!amount) return null;
    return <PaymentPage productType={ProductType.Test} amount={amount} testId={state ? state.testId : null} />
}
export default observer(TestPayment);